module.exports = __webpack_public_path__ + "img/SFProDisplay-Regular.7e78fd3b.svg";